<div class="flex flex-col gap-2 w-full" data-testid="select-skeleton">
  <div class="flex items-center justify-between h-14 w-full rounded border border-outline-variant px-4">
    <app-skeleton width="40%" height="1rem" rounded="sm"></app-skeleton>
    <app-skeleton width="1.25rem" height="1.25rem" rounded="sm"></app-skeleton>
  </div>
  @if (showHint) {
    <app-skeleton width="65%" height="0.75rem" rounded="sm"></app-skeleton>
  }
</div>
